'use client';

import React from 'react';
import { Container } from 'components/shared';
import { BuyNowButton } from 'components/shared/CTAComponent';
import useCluePricing from 'hooks/pricing/useCluePricing';
import { getCompressedAssetUrl } from 'lib/config/assetUrls';
import styles from './Optimize.module.css';

const Optimize = () => {
  const {
    // ringPriceDisplay,
    // clueDiscountedDisplay,
    // cluePriceDisplay,
    bundlePriceDisplay,
  } = useCluePricing();

  return (
    <section
      className={styles.section}
      role="region"
      aria-labelledby="optimize-heading"
    >
      <div
        className={styles.visual}
        aria-label="Optimize sleep and recovery through every cycle"
      >
        <div
          className={styles.placeholder}
          style={
            {
              ['--optimize-bg' as string]: `url(${getCompressedAssetUrl(
                '/web_v2/uh-x-clue/optimize/banner.png',
              )})`,
            } as React.CSSProperties
          }
        />
        {/* <Tint /> */}
        <div className={styles.overlay}>
          {/* <CircleAccent /> */}
          <Container>
            <div className={styles.content}>
              <div className={styles.stack}>
                <h2 className={styles.title} id="optimize-heading">
                  Your complete cycle toolkit is here
                </h2>
                <BuyNowButton
                  className={styles.heroBuyNowButton}
                  href={{ pathname: '/ring/buy', query: { flow: 'clue' } }}
                >
                  Buy bundle for {bundlePriceDisplay}
                </BuyNowButton>
                {/* <Caption>
                  Ring AIR at {ringPriceDisplay}, bundled with Clue Plus for
                  just {clueDiscountedDisplay} (worth {cluePriceDisplay})
                </Caption> */}
              </div>
            </div>
          </Container>
        </div>
      </div>
      <div className={styles.bottomNoteBar}>
        <Container>
          <p className={styles.bottomNote}>
            Ultrahuman Ring AIR is not a medical device and is not intended to
            diagnose, treat, cure, or prevent any medical condition. All
            insights are for general wellness purposes only. Clue is CE marked
            as a Class 1 medical device and includes Clue Conceive, a mode based
            on a clinically validated algorithm designed to support conception.
          </p>
        </Container>
        <div className={styles.separator} />
      </div>
    </section>
  );
};

export default Optimize;
